export enum InvestigationSabrStatus {
	Processing = "PROCESSING",
	Failed = "FAILED",
	NoQuestions = "NO_QUESTIONS",
	Ready = "READY",
}
